import type {ColorPaletteInfo} from '@Libraries/color-palettes.library';

export enum ColorPaletteSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface ColorPaletteProps {
  palette: ColorPaletteInfo | undefined;
  colorPaletteAppliedEvent?: string;
  size?: ColorPaletteSize;
  isSelected?: boolean;
  isBeingApplied?: boolean;
  showNameOverlayOnHover?: boolean;
  onClick?: VoidFunction;
  allowShuffle?: boolean;
  showNameLabel?: boolean;
  showApplyingState?: boolean;
  disableSelection?: boolean;
  onColorPaletteDoneApplying?: () => void;
}

export const DEFAULT_COLORS = ['#D4D4D4', '#ABABAB', '#C3C3C3', '#D5D5D5', '#E4E4E4'];
